import { defineStore } from "pinia";
import DataSource from "devextreme/data/data_source";
import { ref } from "vue";
import { useUserListModel } from "@/stores/models/user-list-model";

export const useUserListStore = defineStore("userListStore", () => {
  const isLoading = ref(false);
  const dataSourceUserList = ref(
    new DataSource({
      requireTotalCount: true,
      store: useUserListModel().userListCustomStore,
      filter: null,
    }),
  );

  const loadData = async (filter = null) => {
    console.log("userListStore loadData 1", filter);
    isLoading.value = true;
    try {
      dataSourceUserList.value.filter(filter);
      // Reload the DataSource with the new filter
      const result = await dataSourceUserList.value.load();
      console.log("userListStore loadData 2", result);
      return result;
    } catch (error) {
      console.error("Error loading data:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  const insertData = async (newItem) => {
    try {
      console.log("userListStore insertData 1", newItem);

      const result = await dataSourceUserList.value.store().insert(newItem);
      return result;
    } catch (error) {
      console.error("Error inserting data:", error);
      throw error;
    }
  };

  const updateData = async (updatedRows) => {
    const store = dataSourceUserList.value.store();
    try {
      // Create an array of update promises
      const updatePromises = updatedRows.map((row) => {
        return store.update(row.id, row); // Assume `id` is the key field
      });

      // Wait for all update operations to complete

      const results = await Promise.all(updatePromises);

      return results;
    } catch (error) {
      console.error("Error updating data:", error);
      throw error;
    }
  };

  const state = ref(true);
  const onMuatButtonClick = () => {
    state.value = false;
    dataSourceUserList.value.reload();
  };

  const initialized = () => {
    dataSourceUserList.value.reload();
  };

  return {
    loadData,
    insertData,
    updateData,
    dataSourceUserList,
    isLoading,
    onMuatButtonClick,
    initialized,
    state,
  };
});
